import App from './App.svelte';


const FLOWER = {image: "./carpet1.jpg"};
const ORANGEBLUE_SCAPE = {image: "./carpet4.jpg"};
const SIDEBYSIDE_COLORS = {image: "./carpet2.jpg"};
const WHITEBG_FLOWER = {image: "./carpet3.jpg"};



const graph = {
    entrance: {
        url: './Corona_Panorama0.jpg',
        initialView: [4889.24, -268.20, 981.75],
        spots: [
            {
                coords: [-494.39, -1185.43, 4830.81],
                digit: 2,
                goto: "left_back"
            },
            {
                coords: [-444.37, -862.71, -4899.13],
                digit: 3,
                goto: "right_back"
            },
            {
                coords: [4911.02, -912.95, -26.89],
                digit: 1,
                goto: "center"
            },

            {
                coords: [4080.57, -135.31, 2874.53],
                show: FLOWER
            },
            {
                coords: [2486.92, -92.41, 4332.72],
                show: ORANGEBLUE_SCAPE
            },
            {
                coords: [3933.19, -106.20, -3070.48],
                show: SIDEBYSIDE_COLORS
            },
            {
                coords: [2263.04, -128.17, -4445.22],
                show: WHITEBG_FLOWER
            },
        ]
    },
    center: {
        url: './Corona_Panorama2.jpg',
        spots: [
            {
                coords: [-91.94, -1020.32, 4886.25],
                goto: 'entrance'
            },
            {
                coords: [1473.78, 93.29, 4770.60],
                digit: 2,
                goto: 'left_back'
            },
            {
                coords: [-1690.17, 98.35, 4695.46],
                digit: 3,
                goto: 'right_back'
            },
            {
                coords: [4988.17, -254.54, 34.90],
                type: 'info',
                show: {film: "SqVsEem79FBf01Fq6NrX8Ihxe1mfX7oVq"}
            },
            {
                coords: [2628.67, -98.74, 4241.95],
                show: FLOWER
            },
            {
                coords: [1891.23, -81.16, 4619.00],
                show: ORANGEBLUE_SCAPE
            },
            {
                coords: [-2993.04, -107.95, 3995.82],
                show: SIDEBYSIDE_COLORS
            },
            {
                coords: [-2147.47, -132.35, 4503.92],
                show: WHITEBG_FLOWER
            },
        ]
    },   
    right_back: {
        url: './Corona_Panorama1.jpg',
        initialView: [4985.14, 362.38, 11.77],
        spots: [
            {
                coords: [-3368.58, -1186.64, 3489.96],
                label: '1',
                goto: 'entrance'
            },
            {
                coords: [4982.23, 283.31, -126.64],
                type: 'info',
                show: {film: "142c02PTeQVlDDPFYUlm8mxSVlV7XE2Db"}
            }
        ]
    },    
    left_back: {
        initialView: [4983.29, 345.86, -59.47],
        url: './Corona_Panorama3.jpg',
        spots: [
            {
                coords: [-3431.78, -980.34, -3486.99],
                label: '1',
                goto: 'entrance'
            },
            {
                coords: [4982.23, 283.31, -126.64],
                type: 'info',
                show: {film: "gkxG8yFYyOxt67fbDwdNemqZV01grTFKW"}
            }
        ]
    }
};
            

const app = new App({
	target: document.body,
	props: {
		initialGraph: graph
	}
});

export default app;